import React from 'react'
import PhotoDefault from '../../../assets/img/photo-default.jpg'

const PerfilAgente = props => {
  return (
    <div className='row dashboard mb-3 mt-3'>
      <div className='col-sm-12 col-md-6'>
        <div className='profile mb-3'>
          <div className='mr-3'>
            <img src={PhotoDefault} alt="Foto padrão" width="100" height="100" />
          </div>
          <div className='pull-left'>
            <span>Olá, <strong>{props.userPerfil.nome}.<br /></strong></span>
            <span>CPF: <strong>{props.userPerfil.cpf}<br /></strong></span>
            <span>Bem vindo ao sistema de gerenciamento de situações do alerta celular.<br /></span>
            <div>
              <button className='btn btn-primary btn-sm' style={{ marginRight: 5 }} onClick={props.showCompImei}>Consultar IMEI's</button>
              <button className='btn btn-danger btn-sm' onClick={() => props.handleLogout()}>Sair</button>
            </div>
          </div>
        </div>
      </div>

      <div className='alert alert-success col-md-6' role='alert'>
        <h4 className='align-text-center'>Gerenciador de situações pendentes</h4>
        <p>Verifique no sistema da policia civil se o dados conferem e altere as situações pendentes.</p>
      </div>
    </div>
  )
}
export default PerfilAgente


// WEBPACK FOOTER //
// ./src/components/Admin/PerfilAgente/index.js